var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid desc"},[_c('SelectItems',{attrs:{"items":_vm.items,"set":_vm.set}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }